import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { putAction } from '@api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: 'AssetDetailsModal',
  mixins: [JeecgListMixin, ModalFormMixin],
  data: function data() {
    return {
      title: '',
      queryParam: {},
      visible: false,
      form_fields: ['surplus', 'usage'],
      validatorRules: {
        usage: {
          rules: [{
            required: true,
            message: '请输入使用量!'
          }, {
            validator: this.checkUsage
          }]
        }
      },
      confirmLoading: false,
      id: '',
      consume: 0,
      outSum: 0,
      url: {
        chemical: "/ea/asset/chemical",
        attachment: "/ea/asset/attachment"
      },
      localUrl: '',
      category: ''
    };
  },
  created: function created() {},
  methods: {
    checkUsage: function checkUsage(rule, value, callback) {
      var sum = Number(value) + this.outSum;
      console.log(this.consume, this.outSum, sum);

      if (value > this.queryParam.surplus) {
        callback(new Error('使用量不能大于剩余量'));

        if (this.consume < sum) {
          callback(new Error('使用量与资产出库量的和不能大于运维消耗量'));
        } else {
          callback();
        }
      } else if (this.consume < sum) {
        callback(new Error('使用量与资产出库量的和大于运维消耗量'));
      } else if (value < 0) {
        callback(new Error('使用量不能为负'));
      } else {
        callback();
      }
    },
    handleOk: function handleOk() {
      var _this = this;

      var that = this;
      this.visible = false;

      if (this.category == 22 || this.category == 23) {
        this.localUrl = this.url.chemical;
      } else if (this.category == 91 || this.category == 92) {
        this.localUrl = this.url.attachment;
      }

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var sums = that.queryParam.usage;
          putAction(_this.localUrl + '/outAssetScattered/' + that.id + '/' + sums).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              _this.queryParam.usage = '';
              that.$emit('ok');
              that.close();
              that.$emit('Outbound');
            } else {
              _this.queryParam.usage = '';
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    }
  }
};